// The first delete confirm, before the server has said anything. A sale with a
// buyer has an invoice, and money received on it stays with the buyer as
// credit (the server asks again if there is any). A walk-in sale has neither:
// its cash posting simply comes off the books (live walk 2, W2-11). A bird
// sale gives its birds back only when it was taken from a flock.
type SaleKind = "egg" | "bird" | "manure" | "bag";

export function deleteSaleMessage(
  kind: SaleKind,
  sale: { buyer_id?: number | null; flock_id?: number | null } | undefined,
): string {
  // The row is gone from the list (reloaded under the dialog): promise nothing.
  if (!sale) return `Delete this ${kind} sale? This cannot be undone.`;
  const birds = kind === "bird" && sale.flock_id != null ? " The birds go back to their flock." : "";
  if (sale.buyer_id == null) {
    return `Delete this ${kind} sale? It was a walk-in sale, so there is no invoice; the cash it brought in comes off the books.${birds} This cannot be undone.`;
  }
  return `Delete this ${kind} sale? Its invoice is deleted with it.${birds} Money already received is not lost — it stays with the buyer as credit, and you are asked first if there is any. This cannot be undone.`;
}
